import * as React from 'react';
import { JSX } from 'react/jsx-runtime';
const CalenderRightIconDark = (
  props: JSX.IntrinsicAttributes & React.SVGProps<SVGSVGElement>,
) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7.7623 21.4891C7.5373 21.4891 7.3498 21.4141 7.1623 21.2641C6.8248 20.9266 6.8248 20.4016 7.1623 20.0641L15.0373 12.0016L7.1623 3.97656C6.8248 3.63906 6.8248 3.11406 7.1623 2.77656C7.4998 2.43906 8.0248 2.43906 8.3623 2.77656L16.8373 11.4016C17.1748 11.7391 17.1748 12.2641 16.8373 12.6016L8.3623 21.2266C8.2123 21.3766 7.9873 21.4891 7.7623 21.4891Z"
      fill="#EEF7FF"
    />
  </svg>
);
export default CalenderRightIconDark;
